(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var hideTimers = new WeakMap();

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function normalizeItems(data) {
    var items = [];
    if (!data) return items;
    if (Array.isArray(data.items)) items = data.items;
    else if (data.id != null) items = [data];
    return items.filter(function (item) {
      var props = item.properties || {};
      return props._bundle_role !== 'addon';
    });
  }

  function esc(str) {
    var el = document.createElement('div');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function renderItem(item) {
    var title = item.product_title || item.title || '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var qty = item.quantity || 1;
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    var price = item.final_line_price != null ? item.final_line_price : (item.price || 0) * qty;
    var imgHtml = img
      ? '<img class="mt-atc-toast__img" src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">'
      : '<span class="mt-atc-toast__img mt-atc-toast__img--placeholder" aria-hidden="true"></span>';

    return (
      '<div class="mt-atc-toast__item">' +
        imgHtml +
        '<div class="mt-atc-toast__meta">' +
          '<p class="mt-atc-toast__title">' + esc(title) + '</p>' +
          (variant ? '<p class="mt-atc-toast__variant">' + esc(variant) + '</p>' : '') +
          '<p class="mt-atc-toast__line">' +
            (qty > 1 ? '<span class="mt-atc-toast__qty">&times;' + qty + '</span> ' : '') +
            '<span class="mt-atc-toast__price">' + esc(formatMoney(price)) + '</span>' +
          '</p>' +
        '</div>' +
      '</div>'
    );
  }

  function findToast(anchor) {
    if (!anchor) return document.querySelector('[data-atc-toast]');
    var root = anchor.closest('.mt-product__block--buy-buttons, .mt-sticky-bar__actions, mt-sticky-bar');
    if (!root) return document.querySelector('[data-atc-toast]');
    return root.querySelector('[data-atc-toast]');
  }

  function hide(toast) {
    if (!toast) return;
    toast.classList.remove('is-visible');
    toast.setAttribute('hidden', '');
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var open = function () {
      if (typeof drawer.open === 'function') drawer.open();
    };
    if (typeof drawer.refresh === 'function') drawer.refresh().then(open);
    else open();
  }

  window.MtAtcToast = {
    isMobile: function () {
      return MOBILE_MQ.matches;
    },

    show: function (anchor, cartData) {
      if (!MOBILE_MQ.matches) return false;

      var toast = findToast(anchor);
      if (!toast) return false;

      var items = normalizeItems(cartData);
      if (!items.length) return false;

      var addedLabel = toast.getAttribute('data-toast-added') || 'Added to cart';
      var viewLabel = toast.getAttribute('data-toast-view-cart') || 'View cart';
      var list = toast.querySelector('[data-atc-toast-list]');
      var heading = toast.querySelector('[data-atc-toast-heading]');

      if (heading) heading.textContent = addedLabel;
      if (list) list.innerHTML = items.map(renderItem).join('');

      var viewBtn = toast.querySelector('[data-atc-toast-view]');
      if (viewBtn) {
        viewBtn.textContent = viewLabel;
        viewBtn.onclick = function (e) {
          e.preventDefault();
          hide(toast);
          openCartDrawer();
        };
      }

      toast.removeAttribute('hidden');
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });

      var prev = hideTimers.get(toast);
      if (prev) clearTimeout(prev);
      hideTimers.set(
        toast,
        setTimeout(function () {
          hide(toast);
        }, 5000)
      );

      return true;
    },

    hide: hide
  };

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-atc-toast-close]');
    if (closeBtn) hide(closeBtn.closest('[data-atc-toast]'));
  });
})();
